module.exports = __webpack_public_path__ + "static/img/18-3.e93841c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/18-3.jpg
// module id = ppf0
// module chunks = 0